import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Multistep from "react-multistep";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import {
  getCustomerMasterlist,
  saveCustomerDetails,
  updateCustomerDetails,
  broadcast_whatsapp_call,
} from "../../../../apiservicescall/api";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
// import PageTitle from "../../../layouts/PageTitle";

const CampaignSteper = () => {
  // const [sendMessage, setSendMessage] = useState(false);
  const [campaign_creation, setCampaign_creation] = useState({
    selected_message_type: "1",
    selected_message_text: "",
    selected_message_file: "",
    selected_message_file_name: "",
    selected_message_template_id: "",
    message_schedule_type: "individual",
    message_recipient_type: "1",
    message_recipient_no: "",
    message_recipient_file: "",
    selected_Latitude: "",
    selected_longitude: "",
  });

  useEffect(() => { }, [campaign_creation]);

  const handleReactSelectChange = (key, value) => {
    debugger
    console.log("valuesadfa sdf", key, value);
    const newFormData = { ...campaign_creation };
    newFormData[key] = value;
    setCampaign_creation(newFormData);
  };

  const submit_campaign_creation = async () => {

    console.log(
      "submit_campaign_creation sdf",
      campaign_creation
    );

    let customerList;
    let url_dynamic;
    let data_dynamic;

    switch (campaign_creation.selected_message_type) {
      case "1":
        data_dynamic = {
          messaging_product: "whatsapp",
          recipient_type: campaign_creation.message_schedule_type,
          to: `${91}${campaign_creation.message_recipient_no}`,
          type: "text",
          text: {
            body: campaign_creation.selected_message_text,
          },
        };
        url_dynamic = "sendMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "2":
        data_dynamic = {
          fileContent: campaign_creation.selected_message_file,
          fileName: "",
          data: {
            messaging_product: "whatsapp",
            recipient_type: campaign_creation.message_schedule_type,
            to: `${91}${campaign_creation.message_recipient_no}`,
            type: "image",
            image: {
              link: "",
              caption: campaign_creation.selected_message_text,
            },
          },
        };
        url_dynamic = "sendImageMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "3":
        data_dynamic = {
          fileContent: campaign_creation.selected_message_file,
          fileName: "",
          data: {
            messaging_product: "whatsapp",
            recipient_type: campaign_creation.message_schedule_type,
            to: `${91}${campaign_creation.message_recipient_no}`,
            type: "audio",
            audio: {
              link: "",
              caption: campaign_creation.selected_message_text,
            },
          },
        };
        url_dynamic = "sendAudioMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);

        break;
      case "4":
        data_dynamic = {
          fileContent: campaign_creation.selected_message_file,
          fileName: "",
          data: {
            messaging_product: "whatsapp",
            recipient_type: campaign_creation.message_schedule_type,
            to: `${91}${campaign_creation.message_recipient_no}`,
            type: "video",
            video: {
              link: "",
              caption: campaign_creation.selected_message_text,
            },
          },
        };
        url_dynamic = "sendVideoMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "5":
        data_dynamic = {
          messaging_product: "whatsapp",
          recipient_type: campaign_creation.message_schedule_type,
          to: `${91}${campaign_creation.message_recipient_no}`,
          type: "location",
          location: {
            latitude: campaign_creation.selected_Latitude,
            longitude: campaign_creation.selected_longitude,
            address: "",
          },
        };
        url_dynamic = "sendLocationMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      case "6":
        data_dynamic = {
          // messaging_product: "whatsapp",
          // recipient_type: "individual",
          // to: "919941855886",
          // type: "text",
          // text: {
          //   body: "welcome",
          // },
        };
        url_dynamic = "sendTemplateTextMessage";
        customerList = await broadcast_whatsapp_call(data_dynamic, url_dynamic);
        break;
      default:
        return alert("something went wrong");
    }
    // const newFormData = { ...campaign_creation };
    // newFormData[key] = value;
    // setCampaign_creation(newFormData);
  };

  const steps = [
    {
      name: "Personal Info",
      component: (
        <StepOne
          handleChange={(key, value) => {
            handleReactSelectChange(key, value);
          }}
          campaign_creation={campaign_creation}
        />
      ),
    },
    {
      name: "Company Info",
      component: (
        <StepTwo
          handleChange={(key, value) => {
            handleReactSelectChange(key, value);
          }}
          campaign_creation={campaign_creation}
        />
      ),
    },
    // {
    //   name: "Business Hours",
    //   component: (
    //     <StepThree
    //       handleChange={(key, value) => {
    //         handleReactSelectChange(key, value);
    //       }}
    //       campaign_creation={campaign_creation}
    //     />
    //   ),
    // },
    {
      name: "Email Setup",
      component: (
        <StepFour
          handleChange={(key, value) => {
            handleReactSelectChange(key, value);
          }}
          campaign_creation={campaign_creation}
          submit_campaign_creation={() => {
            submit_campaign_creation();
          }}
        />
      ),
    },
  ];

  const prevStyle = {
    background: "#F7FAFC",
    borderWidth: "0px",
    color: "#333333",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "600",
    padding: "12px 18px",
    border: "1px solid #EEEEEE",
    marginRight: "1rem",
  };

  const nextStyle = {
    background: "#fd683e",
    borderWidth: "0px",
    color: "#fff",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: "600",
    padding: "12px 18px",
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Create Campaign </h4>

              <Link to={`/Campaign`}>
                <Button
                  variant="contained"
                  // style={{ marginLeft: "50%" }}
                  size="medium"
                >
                  Campaign  List
                </Button>
              </Link>
            </div>

            <div className="card-body">
              <form
                onSubmit={(e) => e.preventDefault()}
                id="step-form-horizontal"
                className="step-form-horizontal"
              >
                <Multistep
                  showNavigation={true}
                  steps={steps}
                  prevStyle={prevStyle}
                  nextStyle={nextStyle}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CampaignSteper;

// const getMenuMasterListMasterApi = async () => {
//   menumasterlabelvalue();
//   setMenuSubmenuItems({
//     menuId: menuSubmenuItems?.menuId,
//     menuName: menuSubmenuItems?.menuName,
//     selectedSubmenuItem: menuSubmenuItems?.selectedSubmenuItem,
//     selectedSubmenuItemValue: menuSubmenuItems?.selectedSubmenuItemValue,
//     subMenuId: menuSubmenuItems?.subMenuId,
//     selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
//     selectedMainmenuItemValue: menuSubmenuItems?.menuId,
//   });
// };
// setMenuSubmenuItems({});
// setMenuSubmenuItems({
//   subMenuName: e.target.value,
// });

// if (key == "itemFoodImage") {
//   const newFormData = { ...menulistitem };
//   newFormData[key] = value.target.files[0];
//   setMenulistitem(newFormData);
// } else {
//   const newFormData = { ...menulistitem };
//   newFormData[key] = value;
//   setMenulistitem(newFormData);
// }
